import { alpha, styled } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { Text } from '@knowz/knowz-ui';

const GRADIENT_SIZE = 0.5;

export const StyledWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'isDragAccept',
})<{ isDragAccept: boolean }>(({ theme, isDragAccept }) => ({
  width: '100%',
  alignSelf: 'flex-end',
  padding: theme.spacing(GRADIENT_SIZE),
  borderRadius: theme.shape.borderRadius * 6.25,
  marginBlockEnd: theme.spacing(1.5),

  ...(isDragAccept && {
    background: theme.palette.createBrandGradients.primary({
      alpha1: alpha(theme.palette.common.white, 0.2),
      alpha2: alpha(theme.palette.common.black, 0.2),
      direction: 'left',
    }),
  }),

  position: 'relative',
}));

export const StyledTextHelper = styled(Text)(({ theme }) => ({
  color: theme.palette.text.disabled,
  textAlign: 'center',

  [theme.breakpoints.up('md')]: {
    fontWeight: theme.typography.fontWeightMedium,
  },

  marginBlockEnd: theme.spacing(1.5),
}));

export const StyledDropAnywhereBox = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',

  background: theme.palette.createBrandGradients.primary({
    alpha1: alpha(theme.palette.common.white, 0.2),
    alpha2: alpha(theme.palette.common.black, 0.2),
    direction: 'left',
  }),

  padding: theme.spacing(GRADIENT_SIZE),
  borderRadius: theme.shape.borderRadius * 2.5,
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  background: theme.palette.background.primary,
  borderRadius: theme.shape.borderRadius * 2.5,
  padding: theme.spacing(1, 3),
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));
